import axios, { AxiosError } from 'axios';
import Settings from '@/config/Settings';
import AuthController from '@/controllers/AuthController';
import { Address } from '@/models/Address';
import UserInfoResponse from '@/models/UserInfoResponse';
import { JsonConvert } from 'json2typescript';
import UserInfo from '@/models/UserInfo';
import AxiosHelper from '@/util/AxiosHelper';
import Response from '@/models/Response';

axios.defaults.withCredentials = true;
axios.defaults.withXSRFToken = true;
axios.defaults.headers.common = { 'Content-Type': 'application/json' };

export default class UserInfoController {
  private static readonly baseUrl = Settings.idUrl + `/api/userinfo`;

  public static async getUserInfo(accessToken: string, refreshing = false): Promise<Response> {
    return await axios
      .get(`${this.baseUrl}`, { headers: { Authorization: accessToken } })
      .then((response) => {
        if (response.status === 200) {
          return UserInfoResponse.buildSuccesResponse(
            new JsonConvert().deserializeObject(response.data, UserInfo),
            accessToken,
            `Profile fetched`,
            'Profiel opgehaald'
          );
        } else {
          return UserInfoResponse.buildFailedResponse(
            `Expected status 200 but got ${response.status}`,
            `Verwachte status is 200, maar ontvangen status is ${response.status}`
          );
        }
      })
      .catch(async (error: Error | AxiosError) => {
        if (!refreshing) {
          const response = await AuthController.refresh();
          if (response && !(response instanceof Response)) {
            const data = response.data as Record<string, string>;
            return await UserInfoController.getUserInfo(data.access_token, true);
          }
          return response;
        } else {
          return AxiosHelper.handleErrorResponse(error);
        }
      });
  }

  public static async updateProfile(
    accessToken: string,
    newGivenName: string,
    newFamilyName: string,
    newPhoneNumber: string,
    newAddress: Address,
    refreshing = false
  ): Promise<Response> {
    return await axios
      .post(
        `${this.baseUrl}`,
        { givenName: newGivenName, familyName: newFamilyName, phoneNumber: newPhoneNumber, address: newAddress },
        { headers: { Authorization: accessToken } }
      )
      .then((response) => {
        if (response.status === 200) {
          return UserInfoResponse.buildSuccesResponse(
            new JsonConvert().deserializeObject(response.data, UserInfo),
            accessToken,
            `Profile updated`,
            'Profiel aangepast'
          );
        } else {
          return UserInfoResponse.buildFailedResponse(
            `Expected status 200 but got ${response.status}`,
            `Verwachte status is 200, maar ontvangen status is ${response.status}`
          );
        }
      })
      .catch(async (error: Error | AxiosError) => {
        if (!refreshing) {
          const response = await AuthController.refresh();
          if (response && !(response instanceof Response)) {
            const data = response.data as Record<string, string>;
            return await UserInfoController.updateProfile(
              data.access_token,
              newGivenName,
              newFamilyName,
              newPhoneNumber,
              newAddress,
              true
            );
          }
          return response;
        } else {
          return AxiosHelper.handleErrorResponse(error);
        }
      });
  }
}
